import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";



function Footer() {
  return (
    <div className="bg-gray-900">
      <div className="container mx-auto ">
        <div className="grid grid-cols-6 gap-6 py-10">
          <div className="col-span-2">
            <Link className="text-white text-3xl font-semibold" to={"/"}>
             MAK Electronics
            
            </Link>
            <p className="text-gray-300 text-xs my-3">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Et fuga
              perferendis fugit, aliquam quo vero. Dignissimos, dolore minima
              soluta eaque corporis quo voluptatum temporibus animi impedit
              fugit sunt laborum. Similique?
            </p>
            <a href="tel:2468965851" className="text-white">
              2468965851
            </a>
          </div>
          

          <div className="col-span-1">
            <p className=" font-semibold text-white mb-5">My Account</p>
            <div className="flex text-sm space-y-2 flex-col">
              <Link className="text-gray-400" to={"/"}>
                My Account
              </Link>
              <Link className="text-gray-400" to={"/"}>
                Order History
              </Link>
              <Link className="text-gray-400" to={"/"}>
                Shopping Cart
              </Link>
              <Link className="text-gray-400" to={"/"}>
                Wishlist
              </Link>
              <Link className="text-gray-400" to={"/"}>
                Settings
              </Link>
            </div>
          </div>


          <div className="col-span-1">
            <p className=" font-semibold text-white mb-5">Help</p>
            <div className="flex text-sm space-y-2 flex-col">
              <Link className="text-gray-400" to={"/"}>
                Contact
              </Link>
              <Link className="text-gray-400" to={"/"}>
                Faqs
              </Link>
              <Link className="text-gray-400" to={"/"}>
                Terms & Condition
              </Link>
              <Link className="text-gray-400" to={"/"}>
                Privacy Policy
              </Link>
            </div>
          </div>

          <div className="col-span-1">
            <p className=" font-semibold text-white mb-5">Connect with Us</p>
            <div className="flex text-sm space-x-5">
              <Link className="text-gray-400" to={"/"}>
              <FaFacebook size={25} />

              </Link>
              <Link className="text-gray-400" to={"/"}>
              <FaInstagram size={25} />

              </Link>
              <Link className="text-gray-400" to={"/"}>
                <FaYoutube size={25} />
              </Link>
              <Link className="text-gray-400" to={"/"}>
              <FaLinkedinIn size={25} />

              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
